define([], function() {
    'use strict';

    function isValidDate(value) {
        return Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value.getTime());
    }

    return isValidDate;
});
